// Material UI
import { makeStyles } from '@material-ui/core';
import Colors from '../../../../constants/Colors';

export default makeStyles(() => ({
  button: {},
  icon: { color: Colors.BLACK },
}));
